import { useEffect } from 'react';

export const usePiTracker = () => {
    useEffect(() => {
        // Pardot
        const checkPardot = setInterval(function () {
            if ((window as any).piTracker) {
                (window as any).piTracker(window.location.href);
                clearInterval(checkPardot);
            } else {
                console.log('piTracker is not available');
                clearInterval(checkPardot);
            }
        }, 100);
        return () => clearInterval(checkPardot);
    }, []);
};
